import { connectHighlight } from 'react-instantsearch-dom';

export const HighlightSnippet = connectHighlight(
    ({ highlight, hit, attribute }) => {
        const parts = highlight({
            highlightProperty: '_highlightResult',
            attribute,
            hit,
        });
        return parts.map((part, i) =>
            part.isHighlighted ? (
                <mark
                    key={i}
                    className="bg-transparent font-semibold italic text-inherit"
                >
                    {part.value}
                </mark>
            ) : (
                <span key={i}>{part.value}</span>
            ),
        );
    },
);

export function getTranslationHighlight(_highlightResult) {
    if (!_highlightResult) return;

    const fields = Object.entries(_highlightResult);
    const matchedFields = [];

    for (let i = 0; i < fields.length; i++) {
        const [fieldName, result] = fields[i];
        // Skip non-name_ fields (products, hashtags, etc.)
        if (!fieldName.startsWith('name')) continue;
        const { matchLevel } = result;
        if (fieldName === 'name' && matchLevel !== 'none') {
            // English name matched — no need to show translation
            return;
        }
        if (fieldName !== 'name' && matchLevel !== 'none') {
            matchedFields.push(fields[i]);
        }
    }

    if (!matchedFields.length) return;

    matchedFields.sort(([, a], [, b]) =>
        a.matchLevel === b.matchLevel ? 0 : a.matchLevel === 'full' ? 1 : -1,
    );

    return matchedFields[0];
}
